export default {
  install(Vue) {
    Vue.prototype.$getLanguageTag = T2G.lang;
  }
};
